import { render, staticRenderFns } from "./CaseEmployeesCompensation.vue?vue&type=template&id=006082e8"
import script from "./CaseEmployeesCompensation.vue?vue&type=script&lang=js"
export * from "./CaseEmployeesCompensation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports